import { Slot, Anchor } from '@costar-ui/components';
import { IconLinkedin2 } from '@costar-ui/icons/csg/IconLinkedin2';
import React from 'react';

var useLinkedInName = function useLinkedInName(linkedInProfile) {
  if (!linkedInProfile || !linkedInProfile.includes('https://www.linkedin.com')) {
    return null;
  }
  var slug = linkedInProfile.split('/in/')[1];
  if (!slug) return null;
  var parts = slug.split('-');
  if (parts.length < 2) return null;
  var capitalize = function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  var firstName = parts[0];
  var lastName = parts[1];
  return "".concat(capitalize(firstName), " ").concat(capitalize(lastName));
};
var LinkedInInfo = function LinkedInInfo(_ref) {
  var linkedInProfile = _ref.linkedInProfile,
    onIconLinkClick = _ref.onIconLinkClick;
  var linkedInName = useLinkedInName(linkedInProfile);
  if (!linkedInProfile || !linkedInName) return null;
  return /*#__PURE__*/React.createElement(Slot, {
    gap: "sm",
    className: "pl-px"
  }, /*#__PURE__*/React.createElement(IconLinkedin2, {
    width: "1.1rem",
    height: "1.1rem",
    className: "text-on-base"
  }), /*#__PURE__*/React.createElement(Anchor, {
    variant: "primary-md",
    href: linkedInProfile,
    onClick: onIconLinkClick,
    target: "_blank",
    testId: "linkedin-link",
    className: "text-wrap"
  }, linkedInName));
};
var LinkedInInfo$1 = LinkedInInfo;

export { LinkedInInfo$1 as default };
//# sourceMappingURL=linkedin-profile.esm.js.map
